import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION6: PdfComponent = {
  type: 'section',
  id: 's6',
  title: '6. Representations, warranties and undertakings of Subscriber',
  content: [
    {
      type: 'bulletList',
      id: 's6bullets',
      bulletType: 'number',
      content: [
        {
          copy: {
            type: 'altText',
            id: 'subWarrants',
            content: ['The Subscriber represents and warrants that:'],
          },
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: {
                  type: 'altText',
                  id: 's6status',
                  content: [
                    'Status.',
                    ' Subscriber is a corporation, duly incorporated, partnership or sole trader and validly existing under the law of its jurisdiction of incorporation and has the power to own its assets and carry on its business as it is being conducted.',
                  ],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: 's6nonconflict',
                  content: [
                    'Non-conflict with other obligations.',
                    ' The entry into and performance by Subscriber of this Agreement do not and will not conflict with:',
                  ],
                },
                sublist: {
                  bulletType: 'roman',
                  content: [
                    {
                      copy: 'any law or regulation applicable to it;',
                    },
                    {
                      copy: 'if a corporation, its constitutional documents;',
                    },
                    {
                      copy: 'any agreement or instrument binding upon it or its assets.',
                    },
                  ],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: 's6power',
                  content: [
                    'Power and authority.',
                    ' Subscriber has the power to enter into, perform and deliver, and has taken all necessary action to authorise its entry into, performance and delivery of this Agreement.',
                  ],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: 's6validity',
                  content: [
                    'Validity and admissibility in evidence.',
                    ' All authorisations required or desirable:',
                  ],
                },
                sublist: {
                  bulletType: 'roman',
                  content: [
                    {
                      copy: 'to enable Subscriber lawfully to enter into, exercise its rights and comply with its obligations in this Agreement; and',
                    },
                    {
                      copy: 'to make this Agreement admissible in evidence in its jurisdiction of incorporation,',
                    },
                  ],
                },
                subcopy:
                  'have been obtained or effected and are in full force and effect.',
              },
              {
                copy: {
                  type: 'altText',
                  id: 's6breach',
                  content: [
                    'No breach of laws.',
                    ' Subscriber has not breached any law or regulation which breach has or is reasonably likely to have a Material Adverse Effect.',
                  ],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: 's6insolvency',
                  content: [
                    'No insolvency.',
                    ' No Insolvency Event has occurred in relation to Subscriber and no corporate action, legal proceeding or other procedure which would comprise an Insolvency Event has been taken or threatened in relation to Subscriber.',
                  ],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: 's6finstat',
                  content: ['Financial statements.'],
                },
                sublist: {
                  bulletType: 'roman',
                  content: [
                    {
                      copy: "Subscriber's consolidated and non-consolidated financial statements are prepared in accordance with GAAP consistently applied;",
                    },
                    {
                      copy: "Subscriber's consolidated and non-consolidated financial statements fairly represent its financial condition as at the end of the relevant financial year and operations during the relevant financial year; and",
                    },
                    {
                      copy: 'there has been no material adverse change in the business or financial condition of Subscriber or the business or consolidated financial condition of Subscriber since the end of the most recent financial year.',
                    },
                  ],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: 's6misleading',
                  content: ['No misleading information.'],
                },
                sublist: {
                  bulletType: 'roman',
                  content: [
                    {
                      copy: 'Any factual information provided by Subscriber in relation to this Agreement was true and accurate in all material respects as at the date it was provided or as at the date (if any) at which it is stated; and',
                    },
                    {
                      copy: 'Nothing has occurred or been omitted from the factual information referred to in (i) above and no information has been given or withheld that results in the factual information referred to in (i) above being untrue or misleading in any material respect.',
                    },
                  ],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: 's6noproceedings',
                  content: [
                    'No proceedings pending or threatened',
                    'No litigation, arbitration or administrative proceedings of or before any court, arbitral body or agency which, if adversely determined, might reasonably be expected to have a Material Adverse Effect has or have (to the best of its knowledge and belief, having made due and careful enquiry) been started or threatened against Subscriber.',
                  ],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: 's6nodefault',
                  content: [
                    'No default.',
                    " No other event or circumstance is outstanding which constitutes a default under any other agreement or instrument which is binding on Subscriber or to which Subscriber's assets are subject, that might have a Material Adverse Effect.",
                  ],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: 's6license',
                  content: [
                    'All licences.',
                    'Subscriber, its employees, contractors, staff, agents and sub-contractors have obtained all licences, approvals, permissions, authorisations, consents, certifications, accreditations, trade body memberships or similar that may be necessary or desirable to enable Subscriber to carry out its business lawfully and to enter into, exercise its rights and comply with its obligations under this Agreement and such remain in full force and effect.',
                  ],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: 's6governing',
                  content: ['Governing law and enforcement.'],
                },
                sublist: {
                  bulletType: 'roman',
                  content: [
                    {
                      copy: 'The choice of English law as the governing law of this Agreement will be recognised and enforced in its jurisdiction of incorporation; and',
                    },
                    {
                      copy: 'Any judgment obtained in England in relation to this Agreement will be recognised and enforced in its jurisdiction of incorporation.',
                    },
                  ],
                },
              },
              {
                copy: {
                  type: 'altText',
                  id: 's6contracts',
                  content: ['Customer contracts.'],
                },
                sublist: {
                  bulletType: 'roman',
                  content: [
                    {
                      copy: 'contain all the terms and conditions under which the Permitted Goods and Services are offered to Customers; and',
                    },
                    {
                      copy: 'reflect the exact versions of the contract(s) used by Subscriber as of the date of this Agreement.',
                    },
                  ],
                },
              },
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'subUndertakes',
            content: ['The Subscriber undertakes and warrants that:'],
          },
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'it shall comply, and shall ensure the compliance of its employees, contractors, staff, agents and sub-contractors, with all Applicable Laws, including, without limitation, the Consumer Protection from Unfair Trading Regulations 2008 and the Consumer Rights Act 2015;',
              },
              {
                copy: 'it shall ensure that employees, contractors, staff, agents and sub-contractors of the Subscriber, where such individuals are involved in the sale of Permitted Goods and Services to Customers, are trained in accordance with the training manual provided by Kanda (if any) prior to any Permitted Goods and Services being sold by such individuals using Credit Agreements, and that such individuals maintain the standards set out in the training manual at all times, and are not incentivised by the Subscriber in a way that increases the conduct risk of the Subscriber or Kanda;',
              },
              {
                copy: 'the Permitted Goods and Services are supplied to the Customer named on the Credit Agreement (or to an authorised third party). For the avoidance of doubt, the Subscriber confirms the foregoing upon submission of a Credit Agreement that has been signed by the Customer;',
              },
              {
                copy: 'it maintains, and will continue to maintain, an appropriate minimum level of professional indemnity insurance and that no warranty scheme is provided to the Customer for longer than 12 months, and that such warranty schemes are backed by a reputable third-party insurance provider or supported by the original manufacturer or supplier. The Subscriber agrees to provide Kanda with evidence of such insurance upon request;',
              },
              {
                copy: 'it shall ensure that a Customer only enters into a Credit Agreement in relation to Permitted Goods and Services, and that the Permitted Goods and Services are only sold through Permitted Sales Channels, always adhering to the obligations notified by Kanda from time to time, and that the description of the Permitted Goods and Services inserted into the Credit Agreement by the Subscriber is true, accurate, complete and not misleading;',
              },
              {
                copy: "it shall ensure that any employees, contractors, staff, agents and sub-contractors comply with the Subscriber's obligations under this Agreement (including, without limitation, the Kanda Procedure Guide), and acknowledges that it remains ultimately responsible for the actions of such persons;",
              },
              {
                copy: 'it only uses the form(s) of contract that were approved by Kanda prior to the parties entering into this Agreement to document agreements between the Subscriber and Customers, unless alternative versions are approved in writing by Kanda, in which case the Subscriber may use such versions (and any validly amended versions) from the date of approval;',
              },
              {
                copy: "it shall always ensure that the Permitted Goods and Services are provided to Customers in compliance with the Subscriber's own policies and procedures that are relevant to the subject matter of this Agreement;",
              },
              {
                copy: 'it shall communicate to all Customers and prospective Customers in a manner which is clear, fair and not misleading;',
              },
              {
                copy: 'it shall not use the trademarks, logos or other intellectual property of any lender introduced via Kanda in the context of advertising, marketing, publishing, communications, or call scripts without the prior written consent of the rights holder;',
              },
              {
                copy: 'in relation to any advertising, marketing, communication, or call script, it shall comply with all Applicable Laws and with any credit-related marketing guidance provided by Kanda from time to time; and',
              },
              {
                copy: 'the Permitted Goods and Services are provided to Customers on the terms of the consumer contract(s) relating to such goods and services, as approved in writing by Kanda prior to entry into this Agreement.',
              },
            ],
          },
        },
        {
          copy: "If the Customer wishes to exercise their right to withdraw from the Credit Agreement, the Subscriber is not authorised to agree to the Customer's request to withdraw. Instead, Kanda will ensure that the Customer is advised, in accordance with the CCR and as set out in the Credit Agreement, that the Customer must notify the relevant lender directly of their intention to withdraw. Kanda will respond to any such Customer request by providing the appropriate lender's contact details so the Customer can notify the lender of their wish to withdraw from the Credit Agreement. This section does not affect the Subscriber's responsibilities in respect of any Customer request to cancel the sale agreement entered into separately by the Subscriber and the Customer under the CCR (where applicable).",
        },
        {
          copy: 'Kanda and Subscriber agree that any breach of this clause 6 would be a Material Breach of this Agreement.',
        },
      ],
      prefix: '6',
    },
  ],
};
